//
import ExtendModel from '@/models/ExtendModel'

/**
 * @class
 * @extends ExtendModel
 */
export default class PchPurchaseInvoice extends ExtendModel {
    /**
     * @description
     *
     */
    static includes = [
        'pch_payment_condition',
        'pch_provider.pch_provider_account',
        'pch_provider_account_movement.pch_type_provider_account_movement',
        'pch_provider_account_movement.pch_provider_payment.pch_detail_provider_payment_sheet',
        'pch_provider_branch_offices.g_commune',
        'pch_purchase_order_has_invoice_numbers.pch_purchase_order.g_originator_user.hr_employee',
        // 'pch_purchase_order_has_invoice_numbers.pch_purchase_order.pch_purchase_order_state',
    ]

    /**
     * @description
     *
     */
    get is_canceled_str() {
        return this.is_canceled ? 'Si' : 'No'
    }

    /**
     * @description
     *
     */
    get is_exent_str() {
        return this.is_exent ? 'Si' : 'No'
    }

    /**
     * @description
     *
     */
    get is_replaced_str() {
        return this.is_replaced ? 'Si' : 'No'
    }

    /**
     * @description
     *
     */
    get pch_payment_condition_type() {
        return this.pch_payment_condition
            ? this.pch_payment_condition.type
            : '-'
    }

    /**
     * @description
     *
     */
    get pch_provider_alias_name() {
        return this.pch_provider ? this.pch_provider.alias_name : '-'
    }

    /**
     * @description
     *
     */
    get pch_provider_branch_offices_address() {
        return this.pch_provider_branch_offices
            ? this.pch_provider_branch_offices.address
            : '-'
    }

    /**
     * @description
     *
     */
    get pch_provider_rut() {
        return this.pch_provider ? this.pch_provider.rut : '-'
    }

    /**
     * @description
     *
     */
    // get pch_purchase_order_has_invoice_numbers() {
    //     return this.pch_purchase_order_has_invoice_numbers.map(r => {
    //         r.g_originator_user_full_name =
    //             r.pch_purchase_order.g_originator_user.hr_employee.names +
    //             ' ' +
    //             r.pch_purchase_order.g_originator_user.hr_employee.last_name1 +
    //             ' ' +
    //             r.pch_purchase_order.g_originator_user.hr_employee.last_name2
    //         r.pch_provider_alias_name = this.pch_provider.alias_name
    //         r.created_at = r.pch_purchase_order.created_at
    //         r.authorization_date = r.pch_purchase_order.authorization_date
    //         r.pch_purchase_order_state_name =
    //             r.pch_purchase_order.pch_purchase_order_state_id
    //         r.total = r.pch_purchase_order.total
    //         return r
    //     })
    // }

    /**
     * @description
     *
     */
    resource() {
        return 'pch_purchase_invoice'
    }
}
